import React from 'react';
import { Alert, AlertTitle, Collapse, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export type ApiError = {
  message: string;
  code?: string;
  details?: string[];
  field?: string;
};

export type ErrorDisplayProps = {
  error: ApiError | null;
  onClose?: () => void;
  showIcon?: boolean;
  fullWidth?: boolean;
  severity?: 'error' | 'warning' | 'info';
  showDetails?: boolean;
  sx?: Record<string, any>;
};

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onClose,
  showIcon = true,
  fullWidth = true,
  severity = 'error',
  showDetails = false,
  sx = {}
}) => {
  if (!error) return null;

  const hasDetails = showDetails && error.details && error.details.length > 0;

  return (
    <Collapse in={!!error}>
      <Alert
        severity={severity}
        sx={{ mb: 2, width: fullWidth ? '100%' : 'auto', ...sx }}
        action={
          onClose ? (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={onClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          ) : undefined
        }
        icon={showIcon ? undefined : false}
      >
        {error.code && <AlertTitle>{error.code}</AlertTitle>}
        {error.message}
        
        {hasDetails && error.details && (
          <Box sx={{ mt: 1 }}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {error.details.map((detail, index) => (
                <li key={index}>{detail}</li>
              ))}
            </ul>
          </Box>
        )}
        
        {error.field && (
          <Box sx={{ mt: 1, fontSize: '0.9em', fontStyle: 'italic' }}>
            Field: {error.field}
          </Box>
        )}
      </Alert>
    </Collapse>
  );
};

export default ErrorDisplay;